var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7192 16.4906C20.1661 15.5344 19.5005 13.7156 19.5005 10.5V9.83438C19.5005 5.68126 16.163 2.27813 12.0567 2.25001H12.0005C11.0152 2.24877 10.0394 2.44192 9.12887 2.8184C8.21837 3.19487 7.39109 3.74727 6.6944 4.44395C5.99772 5.14064 5.44532 5.96792 5.06885 6.87842C4.69237 7.78892 4.49922 8.76474 4.50046 9.75001V10.5C4.50046 13.7156 3.83483 15.5344 3.28171 16.4906C3.14499 16.7183 3.07199 16.9785 3.07034 17.244C3.06869 17.5096 3.13846 17.7707 3.27233 18C3.40359 18.2293 3.59343 18.4196 3.8224 18.5513C4.05138 18.6831 4.31127 18.7517 4.57546 18.75H19.4255C19.6896 18.7517 19.9495 18.6831 20.1785 18.5513C20.4075 18.4196 20.5973 18.2293 20.7286 18C20.8625 17.7707 20.9322 17.5096 20.9306 17.244C20.9289 16.9785 20.8559 16.7183 20.7192 16.4906Z",
    fill: "#AAACAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9902 20.25H8.99023C8.79132 20.25 8.60056 20.329 8.4599 20.4697C8.31925 20.6103 8.24023 20.8011 8.24023 21C8.24023 21.1989 8.31925 21.3897 8.4599 21.5303C8.60056 21.671 8.79132 21.75 8.99023 21.75H14.9902C15.1891 21.75 15.3799 21.671 15.5206 21.5303C15.6612 21.3897 15.7402 21.1989 15.7402 21C15.7402 20.8011 15.6612 20.6103 15.5206 20.4697C15.3799 20.329 15.1891 20.25 14.9902 20.25Z",
    fill: "#AAACAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9b35241e74149b8df897cdca5b2588b8.svg";
export { ForwardRef as ReactComponent };